import { connect } from 'react-redux';
import TdddgCompliance from './TdddgCompliance';
import { STATE_ROOT } from '../../../../../redux';

const mapStateToProps = state => ({
  app: state[STATE_ROOT].apps.details.settings.settings,
});

export default connect(mapStateToProps, null)(TdddgCompliance);
